import React, { useState } from "react";
import styles from "./home.module.css";
import { Col, Row, Form, Alert, Spinner } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
import Header from "../../Component/Header/Header";
import { IoIosAdd } from "react-icons/io";
import { Helmet } from "react-helmet";
import Notification from "../../Component/Notification/Notification";
import { useAuth } from "../../Context/AuthContext";
import { ADD_PUSH_NOTIFICATION } from "../../APIs/BaseUrl";

const PushNotification = () => {
    // const navigate = useNavigate();
    const { toggleNotification } = useAuth();

    const [form, setForm] = useState({
        topic: "all-users",
        title: "",
        description: "",
        intent: "",
        imageUrl: "",
    });
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrorMsg("");
        setSuccessMsg("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");
        setSuccessMsg("");
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(ADD_PUSH_NOTIFICATION, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(form),
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data?.message || "Failed to send notification");
            }
            setSuccessMsg("Push notification sent successfully!");
            setForm({
                topic: "all-users",
                title: "",
                description: "",
                intent: "",
                imageUrl: "",
            });
        } catch (err) {
            setErrorMsg(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <div className="right-aside">
                <Helmet>Push Notification</Helmet>
                <Row>
                    <Col md={!toggleNotification ? 12 : 8} sm={12}>
                        <Header />
                        <div className={styles.head_sec}>
                            <h6>Send Push Notification</h6>
                            <Form onSubmit={handleSubmit} className="mt-3">
                                <Form.Group className="mb-3">
                                    <Form.Label>Topic</Form.Label>
                                    <Form.Select
                                        name="topic"
                                        value={form.topic}
                                        onChange={handleChange}
                                    >
                                        <option value="all-users">All Users</option>
                                        <option value="test-users">Test User</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={form.title}
                                        onChange={handleChange}
                                        placeholder="Enter notification title"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="description"
                                        value={form.description}
                                        onChange={handleChange}
                                        placeholder="Enter notification description"
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Intent ID (optional)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="intent"
                                        value={form.intent}
                                        onChange={handleChange}
                                        placeholder="Enter intent ID (optional)"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Image URL (optional)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="imageUrl"
                                        value={form.imageUrl}
                                        onChange={handleChange}
                                        placeholder="Enter image URL"
                                    />
                                </Form.Group>
                                {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
                                {successMsg && <Alert variant="success">{successMsg}</Alert>}
                                <button
                                    className={`${styles.btn} btn btn-sm btn-dark`}
                                    type="submit"
                                    disabled={loading}
                                >
                                    <IoIosAdd size={20} />{" "}
                                    {loading ? (
                                        <>
                                            <Spinner animation="border" size="sm" /> Sending...
                                        </>
                                    ) : (
                                        "Send Notification"
                                    )}
                                </button>
                            </Form>
                        </div>
                    </Col>
                    {toggleNotification && (
                        <Col md={4} className="p-0">
                            <Notification />
                        </Col>
                    )}
                </Row>
            </div>
        </React.Fragment>
    );
};

export default PushNotification;
